module.exports = __webpack_public_path__ + "static/b9a7bad16efd1c9b7f0af8be9091e683.webp";